
import React from 'react'
import { socialMediaLinksGenerator } from '../SocialMediaLinks'
import { SocialsIconListItems } from '../SocialMediaLinks'
import './socials.css'
import './socials_desktop.css'



export default function Socials() {
    return (
        <div className='main-content'>
            <h1>Socials</h1>
            <hr className='pglayout' />
            <ul id="socials-pg-list" className="icon-links-list">
                <SocialsIconListItems />
            </ul>
        </div>
    )
}